import * as React from 'react';
import {Tabs, TabList, TabPanels, TabPanel, Tab} from '@sail/ui';
import {ExamplePanel} from './utils';
import {ResizableContainer} from '../common/ResizableContainer';

export const Small = () => {
  const [key, setSelectedKey] = React.useState(3);

  return (
    <ResizableContainer minWidth={150} width={500} maxWidth={800}>
      <Tabs size="small" selectedKey={key} onSelectionChange={setSelectedKey}>
        <TabList>
          {[1, 2, 3, 4, 5].map((i) => (
            <Tab key={i}>Tab {i}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {[1, 2, 3, 4, 5].map((i) => (
            <TabPanel key={i}>
              <ExamplePanel>Tab panel {i}</ExamplePanel>
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </ResizableContainer>
  );
};
